<template>
  <div class="main-bas">
    <div class="title-jibne">作品详情</div>

    <el-row class="nave-dd">
      <el-card shadow="never" class="card-aut-cc fail-detail" v-if="registerForm.failDetail">
        <span>补证失败原因：</span> {{ registerForm.failDetail }}
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="span-cc">
          作品详情
          <span class="asfsaefae">流水号: {{ infoForm.dciWorkId }}</span>
        </div>

        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg" v-if="!infoForm.dciCode">
              <div>DCI申请号:</div>
              <div>{{ infoForm.dciContentId }}</div>
            </div>
            <div class="nawe-sadg" v-if="!infoForm.dciCod">
              <div>DCI登记号:</div>
              <div>{{ infoForm.dciCode }}</div>
            </div>
            <div class="nawe-sadg" v-if="!registerForm.regNumber">
              <div>数字版权申请号:</div>
              <div>{{ registerForm.digitalRegisterId }}</div>
            </div>
            <div class="nawe-sadg" v-if="registerForm.regNumber">
              <div>数字版权登记号:</div>
              <div>{{ registerForm.regNumber }}</div>
            </div>
          </div>
          <div>
            <div
              class="showStatus"
              v-if="!!!registerForm.digitalRegisterStatus"
            >
              {{ getLabelByValue(infoForm.dciWorkStatus, statusList) }}
            </div>
            <div class="showStatus">
              {{
                getLabelByValue(
                  registerForm.digitalRegisterStatus,
                  statusListRegis
                )
              }}
            </div>
          </div>
          <!-- 4/26 隐藏所以详情也操作按钮 -->
          <!-- <div v-show="false">
            <div v-if="!!!registerForm.digitalRegisterStatus">
              <el-button
                type="primary"
                v-if="infoForm.dciWorkStatus == 'NO_PAY'"
                @click="pay(infoForm)"
                >支付并提交</el-button
              >
              <el-button
                type="primary"
                v-if="infoForm.dciWorkStatus == 'DCI_PRE_REG_FAIL'"
                @click="workFeedBackClick(infoForm)"
                >申诉</el-button
              >
            </div>
            <div>
              <el-button
                type="primary"
                v-if="registerForm.digitalRegisterStatus == 'NO_APPLY'"
                @click="copyrightCertificate(infoForm)"
                >申领数字版权证书</el-button
              >
              <el-button
                type="primary"
                v-if="registerForm.digitalRegisterStatus == 'FINISH'"
                @click="CertificateDownloadClick(registerForm)"
              >
                证书下载</el-button
              >
              <el-button
                type="primary"
                v-if="registerForm.digitalRegisterStatus == 'PAY'"
                @click="payClick(registerForm, infoForm)"
                >立刻支付</el-button
              >
              <el-button
                type="primary"
                v-if="registerForm.digitalRegisterStatus == 'TOBE_AMEND'"
                @click="reissueCertificateClick(infoForm)"
              >
                立刻补证
              </el-button>
            </div>
          </div> -->
        </div>
      </el-card>
      <el-card
        shadow="never"
        class="card-aut-cc"
        v-if="sameWorkList.length > 1"
      >
        <div class="span-cc">作品列表</div>
        <div class="seccbtn-sfda">
          <div
            :class="chekbtnClassFoList[index]"
            v-for="(item, index) in sameWorkList"
            :key="index + 100"
            @click="chekbtn(index)"
          >
            {{ item.workName }}
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>作品</div>
            </div>
            <div class="nawe-sadg">
              <div>作品名称：</div>
              <div>{{ infoForm.workName }}</div>
            </div>
            <div class="nawe-sadg">
              <div>文件类型:</div>
              <div>{{ infoForm.fileType }}</div>
            </div>
            <div class="nawe-sadg">
              <div>文件名称:</div>
              <div>{{ infoForm.workFileIdLocal }}</div>
            </div>
          </div>
          <div>
            <div>作品样本：</div>
            <div
              class="title-jibne-fsa"
              @click="dialogVisilockClick(infoForm.workFileIdLocal)"
            >
              <i class="el-icon-document"></i>
              <!-- <file-preview
                class="btn-isooreview"
                :file-data="selectedFile"
                :file-type="fileType"
              ></file-preview> -->
            </div>
            <el-button
              class="btn-cc-gres"
              type="primary"
              @click="downCheck(infoForm.workFileIdLocal)"
            >
              下载
            </el-button>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>办理身份:</div>
              <div>{{ clickinfo == 1 ? '著作权人' : '机构代理' }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>作品类型:</div>
              <div>
                {{ getLabelByValue(infoForm.workCategory, WorkCategoryType) }}
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>创作类型:</div>
              <div>原创</div>
            </div>
            <div class="nawe-sadg">
              <div>创作完成日期:</div>
              <div>{{ infoForm.creationCompletionDate }}</div>
            </div>
          </div>
          <div>
            <div class="nawe-sadg"></div>
            <div class="nawe-sadg">
              <div>创作完成地点:</div>
              <div>
                <el-cascader
                  filterable
                  v-model="infoForm.creationCompletionCode"
                  :options="creationCompletionCodeOptions"
                  disabled
                ></el-cascader>
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>发表状态:</div>
              <div>已发表</div>
            </div>
            <div class="nawe-sadg">
              <div>首次发表日期:</div>
              <div>{{ infoForm.firstPublicationDate }}</div>
            </div>
          </div>
          <div>
            <div class="nawe-sadg"></div>
            <div class="nawe-sadg">
              <div>首次发表地点:</div>
              <div>
                <el-cascader
                  filterable
                  v-model="infoForm.firstPublicationCode"
                  :options="creationCompletionCodeOptions"
                  disabled
                ></el-cascader>
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>权利取得方式:</div>
              <div>原创</div>
            </div>
            <div class="nawe-sadg">
              <div>权利归属方式:</div>
              <div>
                {{ getLabelByValue(form.ownershipWay, ownershipWayType) }}
              </div>
            </div>
            <div
              class="nawe-sadg"
              v-for="(item, index) in formAousz.authorNameList"
              :key="index + 300"
            >
              <div>{{ index == 0 ? '著作权人:' : '' }}</div>

              <div>
                {{ item.authorName }}
              </div>
              <div class="nawe-sadg-sdfa">
                {{ item.authorSignature }}
              </div>
            </div>
          </div>
          <div v-if="form.ownershipFileidsLocal">
            <div>法人创作声明：</div>

            <div
              class="title-jibne-fsa"
              @click="dialogVisilockClick(infoForm.workFileIdLocal)"
            >
              <i class="el-icon-document"></i>
              <!-- <file-preview
                :file-data="selectedFileownersh"
                :file-type="fileTypownershe"
              ></file-preview> -->
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>作者:</div>
              <div>{{ form.authorName }}</div>
            </div>
          </div>
          <div>
            <div class="nawe-sadg">
              <div>署名:</div>
              <div>{{ form.authorSignature }}</div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>权利拥有情况:</div>
                <div>{{ getRightScopeLeabe() }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>创作说明:</div>
              <div></div>
            </div>
            <div class="nawe-sadg">
              <div>创作目的:</div>
              <div>{{ registerForm.creationPurpose }}</div>
            </div>
            <div class="nawe-sadg">
              <div>创作过程:</div>
              <div>{{ registerForm.creationProcess }}</div>
            </div>
            <div class="nawe-sadg">
              <div>独创性说明:</div>
              <div>{{ registerForm.originality }}</div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>字体声明:</div>
              <div>
                {{
                  getLabelByValue(registerForm.fontCopyright, originalityType)
                }}
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>肖像权授权文件:</div>
              <div v-if="!!!registerForm.portraitAuthFileidLocal">
                不涉及肖像权
              </div>
              <div v-if="!!registerForm.portraitAuthFileidLocal">有文件</div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>他人作品授权文件:</div>
              <div v-if="!!!registerForm.othersWorkAuthFileidLocal">
                不涉及他人作品
              </div>
              <div v-if="!!registerForm.othersWorkAuthFileidLocal != ''">
                有文件
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="card-aut-cc">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>其他证明文件:</div>
              <div v-if="!!!registerForm.otherFileIdListLocal">
                不涉及其他证明文件
              </div>
              <div v-if="!!registerForm.otherFileIdListLocal">有文件</div>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 检测结果 暂时不显示 -->
      <!-- <el-card shadow="never" class="card-aut-cc" v-if="false">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>检测结果:</div>
              <div class="showStatus-monitor">
                <div class="showStatus-cc">
                  {{ setworkINfo() }}
                </div>

                <div v-if="form.monitorPayStatus != 'WORKING'">
                  <el-button
                    type="primary"
                    v-if="form.monitorPayStatus == 'PAIED'"
                    @click="monitorFicate()"
                    >提交监测</el-button
                  >
                  <el-button
                    type="primary"
                    v-if="form.monitorPayStatus == 'NO_PAY'"
                    @click="monitorFicatesdaf()"
                    >监测支付</el-button
                  >
                </div>
              </div>
            </div>
            <div class="nawe-sadg" v-if="monitorStart">
              <div>监测时间:</div>
              <div>{{ monitorStart }}</div>
            </div>
          </div>
        </div>
      </el-card> -->
      <!-- 取证结果 暂时不显示 -->
      <!-- <el-card shadow="never" class="card-aut-cc" v-if="false">
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>取证结果:</div>
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="5">
            <div v-if="recordScreenHistinfo">取证时间</div>
            <div v-if="recordScreenHistinfo">
              {{ recordScreenHistinfo.updateTime }}
            </div>
          </el-col>
          <el-col :span="5">
            <div v-if="recordScreenHistinfo">取证方式</div>
            <div v-if="recordScreenHistinfo">
              {{ recordScreenHistinfo.name }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>取证结果</div>
            <div>{{ recordScreenHistinfo ? '成功' : '未取证' }}</div>
          </el-col>
          <el-col :span="5">
            <div>操作</div>
            <div>
              <el-button
                type="text"
                @click="payRecordScreenCkick"
                v-if="
                  form.recordScreenPayStatus == 'NO_PAY' ||
                  form.recordScreenPayStatus == 'PAYING'
                "
              >
                取证支付
              </el-button>
              <el-button
                type="text"
                @click="payRecordScreenPAIED"
                v-if="form.recordScreenPayStatus == 'PAIED'"
              >
                取证提交
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-card> -->

      <div class="aewfasef">
        <div class="span-cc">数登发票信息:</div>
        <div class="never-span-cc">
          <div>
            <div class="nawe-sadg">
              <div>类型:</div>
              <div>增值税普通发票</div>
            </div>
            <div class="nawe-sadg">
              <div>抬头:</div>
              <div>{{ registerForm.invoiceHeader }}</div>
            </div>
            <div class="nawe-sadg">
              <div>发票号:</div>
              <div>无</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <el-card shadow="never" class="card-aut-cc">
        <el-button @click="onSubmitisLook"> 返回 </el-button>
      </el-card> -->
    </el-row>

    <el-dialog title="监测" :visible.sync="dialogVisible" width="50%">
      <el-input v-model="keyWord" placeholder="监测关键词（选填）"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleClick">确 定</el-button>
      </span>
    </el-dialog>

    <!-- <el-button type="primary" @click="tesx()">监测支付</el-button> -->

    <el-dialog title="支付提示" :visible.sync="dialogVisible2" width="50%">
      <div>
        付款成功后该订单下的所有产品都将运入后台审核阶段，请持续关注列表状态（也可手动刷新）。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleClick2"
          >知道啦</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="预览" :visible.sync="dialogVisilock" width="80%">
      <file-preview
        class="btn-isooreview"
        :file-data="selectedFile"
        :file-type="fileType"
        style="width: 100%; height: 68vh"
      ></file-preview>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downCheck(dialogVisilockpath)"
          >下载</el-button
        >
        <el-button @click="dialogVisilock = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  upload,
  workSave,
  userList,
  workInfo,
  workUpdate,
  getByCertNo,
  registrationInfo,
  createMonitorTask,
  payDciWork,
  queryMonitorResult,
  getMonitorRecord,
  payMonitor,
  payRecordScreen,
  getPayResult,
  createRecordScreen,
  getRecordScreenHis
} from '@/api/user.js'
// cardOptions 从 window.CARD_OPTIONS 获取（在 index.html 中预加载）
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      dialogVisilock: false,
      selectedFile: '',
      fileType: '',
      dialogVisible2: false,
      isLook: false,
      active: 0,
      // 1我是著作权人 2我是机构代理
      clickinfo: 1,
      form: {
        // 作品名称，最长50个字符
        workName: '',

        // DCI用户ID，通过DCI用户注册获取
        dciUserId: '',

        // 作品类型，详见 WorkCategory 文档
        workCategory: '',

        // 作品文件路径，通过 getUploadUrl 接口上传文件获取
        workFileId: '',

        // 文件类型，详见 FileType 文档
        fileType: '',

        // 创作信息，详见 DciCreationInfo 文档
        creationNature: 'ORIGINAL', // 作品创作性质
        creationCompletionDate: '', // 创作完成日期
        creationCompletionCode: '', // 地区编码

        // 发表信息，详见 DciPublicationInfo 文档
        publicationStatus: 'PUBLISHED', // 作品发表状态
        firstPublicationDate: '', // 首次发表日期
        firstPublicationCode: '', // 首次发表地区编码

        // 作者姓名，需与著作权人姓名保持一致
        authorName: '',

        // 作者署名，需与 authorName 保持一致
        authorSignature: '',

        // 原创声明（选填）
        originalStatement: '',

        // 权利信息，详见 DciRightInfo 文档
        rightScope: 'ALL', // 作品权利范围
        rightObtainWay: 'ORIGINAL', // 权利取得方式
        ownershipWay: 'PERSON', // 权利归属方式

        // 真实意愿表达信息，详见 PreRegistrationTrueWill 文档
        preRegistrationTrueWill: 'PASSWORD',

        // 暂时不传
        // 著作权人用户id列表，长度为1且著作权人需与申请人一致
        copyrightOwnerIds: '[]',

        // A音视频文件播放分钟时长，向上取整
        fileDurationMinutes: 0,
        // A文件大小，向上取整 MB
        fileSize: 0,
        // A代理人id sys_user表id
        proxy: '',
        // A作品文件路径 202211251400chushibiao.pdf 文件OSS Id,通过getUploadUrl接口上传文件获取
        workFileId: '',
        // A作品文件路径 本系统OSS
        workFileIdLocal: ''
      },
      fileTypeType: [
        { value: 'TEXT', label: '文本（限制pdf类型）（限制文件大小10M）' },
        {
          value: 'IMAGE',
          label:
            '图片（限制jpg、jpeg、png类型）（限制文件大小5M）（图片像素不低于400x400，不高于5000x5000）'
        },
        {
          value: 'AUDIO',
          label: '音频（限制mp3、wav类型）（限制文件大小50M）'
        },
        {
          value: 'VIDEO',
          label: '视频（限制mp4、avi、wmv类型）（限制文件大小200M）'
        },
        {
          value: 'PDF_IMAGE',
          label: '系列图（限制pdf类型）（限制文件大小10M）(限制子图数量2-30)'
        }
      ],
      originalityType: [
        { value: 'NO_NEED', label: '不涉及字体版权' },
        { value: 'FREE_FONT', label: '公共免费字体' },
        { value: 'ORIGINAL_FONT', label: '原创字体' },
        { value: 'AUTHORIZED_FONT', label: '商用字体已授权' },
        { value: 'OPEN_SOURCE_FONT', label: '开源字体' }
      ],
      WorkCategoryType: [
        {
          /**
           * 文字作品，支持文件类型 TEXT
           */
          value: 'WORD',
          label: '文字作品，支持文件类型 TEXT'
        },
        {
          /**
           * 口述作品，支持文件类型 AUDIO
           */
          value: 'ORAL',
          label: '口述作品，支持文件类型 AUDIO'
        },
        {
          /**
           * 音乐作品，支持文件类型 AUDIO
           */
          value: 'MUSIC',
          label: '音乐作品，支持文件类型 AUDIO'
        },
        {
          /**
           * 戏剧作品，支持文件类型 TEXT
           */
          value: 'DRAMA',
          label: '戏剧作品，支持文件类型 TEXT'
        },
        {
          /**
           * 曲艺作品，支持文件类型 TEXT
           */
          value: 'QUYI',
          label: '曲艺作品，支持文件类型 TEXT'
        },
        {
          /**
           * 舞蹈作品，支持文件类型 VIDEO
           */
          value: 'DANCE',
          label: '舞蹈作品，支持文件类型 VIDEO'
        },
        {
          /**
           * 杂技作品，支持文件类型 VIDEO
           */
          value: 'ACROBATICS',
          label: '杂技作品，支持文件类型 VIDEO'
        },
        {
          /**
           * 美术作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'ART',
          label: '美术作品，支持文件类型 IMAGE、PDF_IMAGE'
        },
        {
          /**
           * 建筑作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'ARCHITECTURE',
          label: '建筑作品，支持文件类型 IMAGE、PDF_IMAGE'
        },
        {
          /**
           * 摄影作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'PHOTOGRAPHY',
          label: '摄影作品，支持文件类型 IMAGE、PDF_IMAGE'
        },
        {
          /**
           * 电影作品，支持文件类型 VIDEO
           */
          value: 'MOVIE',
          label: '电影作品，支持文件类型 VIDEO'
        },
        {
          /**
           * 类似摄制电影方法创作的作品，支持文件类型 VIDEO
           */
          value: 'AUDIOVISUAL',
          label: '类似摄制电影方法创作的作品，支持文件类型 VIDEO'
        },
        {
          /**
           * 工程设计图、产品设计图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'DESIGN',
          label: '工程设计图、产品设计图，支持文件类型 IMAGE、PDF_IMAGE'
        },
        {
          /**
           * 示意图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'DIAGRAM',
          label: '示意图，支持文件类型 IMAGE、PDF_IMAGE'
        },
        {
          /**
           * 模型，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'MODEL',
          label: '模型，支持文件类型 IMAGE、PDF_IMAGE'
        }
      ],
      creationCompletionCodeOptions: window.CARD_OPTIONS || [],
      rightScopeType: [
        { value: 'ALL', label: '全选' },
        { value: 'PUBLISH', label: '发表权' },
        { value: 'AUTHORSHIP', label: '署名权' },
        { value: 'MODIFY', label: '修改权' },
        { value: 'PROTECT_INTEGRITY', label: '保护作品完整权' },
        { value: 'COPY', label: '复制' },
        { value: 'ISSUE', label: '发行权' },
        { value: 'RENTAL', label: '出租' },
        { value: 'EXHIBIT', label: '展览权' },
        { value: 'PERFORM', label: '表演权' },
        { value: 'SHOW', label: '放映权' },
        { value: 'BROADCAST_TRADITIONAL', label: '广播权' },
        { value: 'INFO_NET_SPREAD', label: '信息网络传播权' },
        { value: 'CAMERA', label: '摄制权' },
        { value: 'REVISE', label: '改编权' },
        { value: 'TRANSLATE', label: '翻译权' },
        { value: 'COMPILE', label: '汇编权' },
        { value: 'OTHERS', label: '其他' }
      ],
      ownershipWayType: [
        { value: 'PERSON', label: '个人作品' },
        { value: 'ENTERPRISE', label: '法人作品' },
        { value: 'EMPLOYMENT', label: '职务作品' },
        { value: 'COMISSION', label: '委托作品' }
      ],
      preRegistrationTrueWillType: [
        { value: 'PASSWORD', label: '密码验证' },
        { value: 'CONFIRM_SMS', label: '用户短信验证' },
        { value: 'LIVE_SMS', label: '指纹或视频人脸验证' },
        { value: 'CERTIFICATE', label: '电子签名验证' }
      ],
      // 著作权人用户id列表 后台获取
      copyrightOwnerIdsType: [
        {
          value: '', //id
          label: '', //名字
          authorSignature: '' //证件号
        }
      ],
      // 状态列表
      statusList: [
        { value: 'WORKING', label: '监测中' },
        { value: 'NO_PAY', label: '待支付' },
        { value: 'PAYING', label: '支付中' },
        { value: 'PAIED', label: '已支付' },
        { value: 'DCI_PRE_REG_AUDITING', label: '申领审核中' },
        { value: 'DCI_PRE_REG_FINISH', label: '申领成功' },
        { value: 'DCI_PRE_REG_FAIL', label: '申领失败' },
        { value: 'DCI_PRE_REG_CANCEL', label: 'dci撤销' },
        {
          value: 'DCI_PRE_REG_TOBE_CONFIRM',
          label: '申领待确认，账户余额不足'
        }
      ],
      // 状态列表
      statusListRegis: [
        {
          value: 'TOTAL',
          label: '全部'
        },
        {
          value: 'NO_APPLY',
          label: '未申请'
        },
        {
          value: 'SUBMITED',
          label: '已提交'
        },
        {
          value: 'CHECK',
          label: '初审中'
        },
        {
          value: 'PAY',
          label: '待支付'
        },
        {
          value: 'REVIEW',
          label: '审查中'
        },
        {
          value: 'TOBE_AMEND',
          label: '补正'
        },
        {
          value: 'DISREGARD',
          label: '不予受理'
        },
        {
          value: 'FINISH',
          label: '已下证'
        }
      ],
      formAousz: {
        authorNameList: [
          {
            // 证件名字
            authorName: '',
            // 证件号码
            authorSignature: ''
          }
        ] // 人员列表
      },
      sameWorkList: {},
      infoForm: {},
      fileList: [],
      registerForm: {}, // 数登信息
      dialogVisible: false,
      dialogVisibleID: '',
      keyWord: '',
      selectedFileownersh: '',
      fileTypownershe: '',
      isLookPreview: true,
      dialogVisilockpath: '',
      monitorTaskId: '',
      monitorStart: '',
      monitorEnd: '',
      recordScreenHistinfo: {}
    }
    // form.monitorPayStatus == "WORKING" ? "监测中" : ""
  },
  computed: {},
  watch: {},
  async created () {
    // const res = await userList();// 获取著作权人列表
    // if (res && res.code == 200) {
    //   this.copyrightOwnerIdsType = []
    //   res.rows.map(e => {
    //     this.copyrightOwnerIdsType.push({
    //       value: e.dciUserId,
    //       label: e.certName,
    //       authorSignature: e.certificateNumber
    //     })
    //   })
    // }
    if (this.$route.query.dciWorkId) {
      this.dciWorkId = this.$route.query.dciWorkId
      const res = await workInfo({
        dciWorkId: this.$route.query.dciWorkId
      })
      if (res && res.code == 200) {
        this.infoForm = { ...res.data }
        this.sameWorkList = { ...res.data }
        this.form = res.data

        // 是否代理
        if (res.data.proxy) {
          this.clickinfo = 2
        }
        // 反显著作人信息
        if (!this.isArrayEmptyOrContainsOnlyEmptyString(res.data.copyrightOwnerIds)) {
          this.formAousz.authorNameList = []
        }

        this.copyrightOwnerIdsType = []
        const resUser = await userList(res.data.copyrightOwnerIds || []);// 获取著作权人列表
        if (resUser && resUser.code == 200) {
          resUser.rows.map(e => {
            this.copyrightOwnerIdsType.push({
              value: e.dciUserId,
              label: e.certName,
              authorSignature: e.certificateNumber
            })
            this.formAousz.authorNameList.push({
                authorName: e.certName, //名字
                authorSignature: e.certificateNumber //证件号
              })
          })
        }

        // res.data.copyrightOwnerIds.map(e => {
        //   this.copyrightOwnerIdsType.map(i => {
        //     if (i.value == e) {
        //       this.formAousz.authorNameList.push({
        //         authorName: i.label, //名字
        //         authorSignature: i.authorSignature //证件号
        //       })
        //     }
        //   })
        // })
      }

      if (this.$route.query.monitorPayStatus) {
        getMonitorRecord({
          workId: this.$route.query.dciWorkId,
          isAsc: 'desc'
        }).then(async res => {
          if (res.rows.length == 0) return
          const monitorStartdate = new Date(res.rows[0].monitorStart)
          const starformattedDate = monitorStartdate.toISOString().split('T')[0]

          this.monitorTaskId = res.rows[0].monitorTaskId
          this.monitorStart = starformattedDate
          this.monitorEnd = res.rows[0].monitorEnd
          this.form.monitorPayStatus = this.$route.query.monitorPayStatus

          const queryMonitor = await queryMonitorResult({
            monitorTaskId: this.monitorTaskId
          })
          if (queryMonitor && queryMonitor.code == 200) {
          }
        })
      }
    }
    if (this.$route.query.dciContentId) {
      const res2 = await registrationInfo({
        contentId: this.$route.query.dciContentId
      })
      if (res2 && res2.code == 200) {
        if (res2.data) {
          this.registerForm = res2.data
        }
      }
    }

    const res3 = await getRecordScreenHis({
      workId: this.$route.query.dciWorkId,
      isAsc: 'desc'
    })
    if (res3 && res3.code == 200) {
      this.recordScreenHistinfo = res3.rows[0]
    }
  },
  async mounted () {},
  methods: {
    isArrayEmptyOrContainsOnlyEmptyString (arr) {
      // 检查数组是否为空
      if (arr.length === 0) {
        return true // 数组为空
      }

      // 检查数组是否只包含一个空字符串
      if (arr.length === 1 && arr[0] === '') {
        return true // 数组只包含一个空字符串
      }

      return false // 数组不为空且不只包含一个空字符串
    },
    getRightScopeLeabe () {
      const result = this.rightScopeType
        .filter(option => this.form.rightScope.split(',').includes(option.value))
        .map(option => option.label).join('、')
      console.log(result, 'zzzzzzzzzzzz')

      return result
    },
    updateMonitorStatus (newValue) {
      // 1. 获取当前完整 URL
      const fullUrl = window.location.href

      // 2. 分割哈希部分（如 "#/InfoLock?dciWorkId=...&monitorPayStatus=NO_PAY"）
      const hashPart = fullUrl.split('#')[1] || ''

      // 3. 分割哈希路径和参数（处理格式如 "/InfoLock?dciWorkId=..."）
      const [hashPath, hashParams] = hashPart.split('?')

      // 4. 解析原有参数
      const params = new URLSearchParams(hashParams || '')

      // 5. 修改目标参数
      params.set('monitorPayStatus', newValue)

      // 6. 构建新的哈希部分
      const newHash = `#${hashPath}?${params.toString()}`

      // 7. 拼接完整 URL 并跳转（触发页面刷新）
      const newUrl = `${fullUrl.split('#')[0]}${newHash}`
      window.location.href = newUrl
      window.location.reload()
    },
    setworkINfo () {
      let resTex = ''
      if (!this.$route.query.monitorPayStatus) return
      console.log(this.$route.query.monitorPayStatus, 'zzzzzzzzzzzzz')
      const title = this.getLabelByValue(
        this.$route.query.monitorPayStatus,
        this.statusList
      )
      resTex = title
      if (title == '监测中') {
        resTex = this.getTimeRemaining(this.monitorEnd)
      }
      return resTex
    },
    getTimeRemaining (targetDate) {
      // 获取当前时间和目标时间
      const now = new Date()
      const target = new Date(targetDate)

      // 计算时间差（单位：毫秒）
      const timeDiff = target - now

      // 如果目标时间已经过去，返回提示
      if (timeDiff <= 0) {
        return '已过期'
      }

      // 计算天、小时、分钟
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

      // 返回结果
      return `监测中（${days}天 ${hours}小时 ${minutes}分钟）`
    },
    async dialogVisilockClick (path) {
      this.dialogVisilock = true
      this.dialogVisilockpath = path
      const resUrl = await this.$download.file(path)
      this.selectedFile = resUrl
      this.fileType = path.split('/')[0]
    },
    dialogVisibleClick2 () {
      // 刷新当前页面
      location.reload()
    },
    // 证书下载
    // CertificateDownloadClick (row) {
    //   const parts = row.applyFormUrl.split('/')
    //   this.$download.name(row.downloadUrl, parts[1] + '.' + parts[0])
    // },
    // async reissueCertificateClick (row) {
    //   const res = await payRecordScreen({ dciWorkId: row.dciWorkId })
    //   if (res.code == 200) {
    //     // 打开一个空白的新窗口
    //     const newWindow = window.open('', '_blank', 'width=800,height=600')
    //     newWindow.document.write(res.msg)
    //   }
    // },
    // 立刻支付
    // async payClick (row, infoForm) {
    //    // TODO: 调用支付宝支付接口
    //   if (row.serviceFeeStatus == 'PAIED') {
    //     // 【跳转支付页面
    //     const res2 = await dciGetPayUrl([row.digitalRegisterId])
    //     if (res2.code == 200) {
    //       window.open(res2.msg, '_blank')
    //     }
    //     return
    //   }
    //   const res = await payDigitalReg([infoForm.dciWorkId], {
    //     phone: '17775134263',
    //     smsCode: '666'
    //   })
    //   if (res.code == 200) {
    //     // 打开一个空白的新窗口
    //     const newWindow = window.open('', '_blank', 'width=800,height=600')
    //     newWindow.document.write(res.msg)
    //   }
    //   this.dialogVisible2 = true
    // },
    // 申领数字版权证书
    // async copyrightCertificate (row) {
    //   this.$router.push({
    //     path: '/DigitalCopyrightRegistrationEdit',
    //     query: {
    //       dciWorkId: row.dciWork.dciWorkId,
    //       dciContentId: row.dciContentId
    //     }
    //   })
    // },
    workFeedBackClick (row) {
      this.$router.push({
        path: '/DCIFeedBackSubmit',
        query: { dciWorkId: row.dciWorkId }
      })
    },
    // 点击支付
    async pay (row) {
      const res = await payDciWork([row.dciWorkId], {
        phone: '17775134263',
        smsCode: '666'
      })
      if (res.code == 200) {
        // 打开一个空白的新窗口
        const newWindow = window.open('', '_blank', 'width=600,height=400')
        newWindow.document.write(res.msg)
        this.dialogVisible2 = true
      }
    },
    // 监测支付
    async monitorFicate () {
      this.dialogVisible = true
      this.dialogVisibleID = this.$route.query.dciWorkId
    },
    // // 取证支付
    // async payRecordScreenCkick () {
    //   if (this.form.recordScreenPayStatus == 'PAYING') {
    //     // 支付类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
    //     const res = await getPayResult({
    //       dciWorkId: this.$route.query.dciWorkId,
    //       bizType: 'RECORD_SCREEN'
    //     })
    //     if (res.code != 200) {
    //       return
    //     }
    //   }
    //   const res = await payRecordScreen({
    //     dciWorkId: this.$route.query.dciWorkId
    //   })
    //   if (res.code == 200) {
    //     // 打开一个空白的新窗口
    //     const newWindow = window.open('', '_blank', 'width=600,height=400')
    //     newWindow.document.write(res.msg)
    //     this.dialogVisible2 = true
    //   }
    // },
    // async payRecordScreenPAIED () {
    //   const res = await createRecordScreen({
    //     workId: this.$route.query.dciWorkId
    //   })
    //   if (res.code == 200) {
    //     this.$message.success('取证提交成功')
    //     window.location.reload()
    //   }
    // },
    // 监测支付
    // async monitorFicatesdaf () {
    //   if (this.form.monitorPayStatus == 'PAYING') {
    //     // 支付类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
    //     const res = await getPayResult({
    //       dciWorkId: this.$route.query.dciWorkId,
    //       bizType: 'MONITOR'
    //     })
    //     if (res.code != 200) {
    //       return
    //     }
    //   }
    //   const res = await payMonitor({ dciWorkId: this.$route.query.dciWorkId })
    //   if (res.code == 200) {
    //     // 打开一个空白的新窗口
    //     const newWindow = window.open('', '_blank', 'width=600,height=400')
    //     newWindow.document.write(res.msg)
    //     this.dialogVisible2 = true
    //   }
    // },
    //监测提交
    async dialogVisibleClick () {
      const res = await createMonitorTask({
        keyWord: this.keyWord,
        workId: this.dialogVisibleID
      })
      if (res && res.code == 200) {
        this.$message.success('监测提交成功')

        this.updateMonitorStatus('WORKING')
      }
    },
    getLabelByValue (value, works) {
      const found = works.find(work => work.value === value)
      return found ? found.label : value
    },
    chekbtn (i) {
      this.infoForm = this.sameWorkList[i]
      for (let index = 0; index < this.sameWorkList.length; index++) {
        if (i == index) {
          this.$set(this.chekbtnClassFoList, index, 'chekbtn')
        } else {
          this.$set(this.chekbtnClassFoList, index, '')
        }
      }
    },
    onSubmitUpdate () {
      this.$refs.formName2.validate(async valid => {
        if (valid) {
          // 著作人处理
          if (this.formAousz.authorNameList.length > 0) {
            let isMubl = true
            this.form.copyrightOwnerIds = []

            for (
              let index = 0;
              index < this.formAousz.authorNameList.length;
              index++
            ) {
              const e = this.formAousz.authorNameList[index]
              const res = await getByCertNo({
                certNo: e.authorSignature,
                certName: e.authorName
              })
              if (res.code == 200) {
                this.form.copyrightOwnerIds.push(res.data.dciUserId)
                this.copyrightOwnerIdsList.push(res.data) // 储存多个著作人信息
              } else {
                isMubl = false
                this.$message.error('证件号有误：' + res.msg)
                return false
              }
            }

            if (!isMubl) return // 证件号有误阻止流程
            this.form.dciUserId = this.copyrightOwnerIdsList[0].dciUserId
            this.form.authorName = this.copyrightOwnerIdsList[0].certName
            this.form.authorSignature = this.copyrightOwnerIdsList[0].certName
          }

          this.infoForm = this.sameWorkList[0]
          this.active = 3
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    async onSubmitisLook3 () {
      for (let index = 0; index < this.sameWorkList.length; index++) {
        const element = this.sameWorkList[index]

        const res = await workUpdate({
          ...this.form,
          ...element,
          dciUserId: this.form.dciUserId,
          authorName: this.form.authorName,
          authorSignature: this.form.authorSignature
        })
        console.log(res, 'res')
        if (res.code == 200) {
          this.$message.success('更新作品信息成功')
        } else {
          this.$message.error('更新作品信息失败' + res.msg)
          return false
        }
      }
      this.$router.push('/DCIRegistration')
    },
    onSubmitisLook () {
      this.$router.push({
        path: '/DCIRegistration'
      })
    },
    beforeAvatarUpload (file) {},
    handleChange (file) {
      this.file = file.raw
    },
    beforeRemove (file, fileList) {
      this.file = null
    },
    downCheck (path) {
      const parts = path.split('/')
      this.$download.name(path, parts[1] + '.' + parts[0])
    },
    getNewData () {
      // 获取当前日期对象
      const today = new Date()

      // 提取年、月、日
      const year = today.getFullYear()
      let month = today.getMonth() + 1 // 月份从0开始，需要加1
      let day = today.getDate()

      // 手动补零函数
      function padZero (num) {
        return num < 10 ? '0' + num : num
      }

      // 格式化月份和日期
      month = padZero(month)
      day = padZero(day)

      // 组合成指定格式字符串
      return `${year}-${month}-${day}`
    },
    async nextClick () {
      // 选择我是个人  著作权人不填代理人字段
      if (this.clickinfo == 1) {
        this.copyrightOwnerIdsType = []
        const resUser = await userList([this.userInfo.dciUserId])
        if (resUser && resUser.code == 200) {
          resUser.rows.map(e => {
            this.copyrightOwnerIdsType.push({
              value: e.dciUserId,
              label: e.certName,
              authorSignature: e.certificateNumber,
            })
          })
        }
        this.copyrightOwnerIdsType.map(e => {
          console.log(this.formAousz.authorNameList)
          if (e.value == this.userInfo.dciUserId) {
            this.formAousz.authorNameList[0].authorName = e.label
            this.formAousz.authorNameList[0].authorSignature = e.authorSignature
            this.form.authorName = e.label
            this.form.authorSignature = e.label
          }
        })
      }
      // 在编辑某条表格记录
      let itemListId = 0
      if (this.sameWorkListitemID) {
        this.sameWorkList.map((e, i) => {
          if (e.dciWorkId == this.sameWorkListitemID) {
            itemListId = i + 1
          }
        })
      }
      if (this.sameWorkList.length > 0) {
        if (this.form.workName) {
          this.$refs.formName.validate(async valid => {
            if (valid) {
              const date1 = new Date(this.form.creationCompletionDate)
              const date2 = new Date(this.form.firstPublicationDate)

              if (date1 > date2) {
                this.$message.error('首次发表日期不能早于创作完成日期')
                return
              }
              let workFileId = ''
              let workFileIdLocal = ''
              let fileSize = ''
              let fileDurationMinutes = ''
              if (this.file) {
                let FrontFileId = new FormData()
                FrontFileId.append('file', this.file)
                const resFront = await upload(FrontFileId)
                if (resFront.code == 200) {
                  workFileId = resFront.dciFile
                  workFileIdLocal = resFront.ossFile
                  fileSize = resFront.fileSize
                  fileDurationMinutes = resFront.durationMinutes
                } else {
                  this.$message.error(resFront.msg)
                  return false
                }
              } else {
                if (this.dciWorkId && !this.isLook) {
                  // 更新状态
                  workFileId = this.form.workFileId
                  workFileIdLocal = this.form.workFileIdLocal
                  fileSize = this.form.fileSize
                  fileDurationMinutes = this.form.fileDurationMinutes
                } else {
                  this.$message.error('请填选择文件')
                  return false
                }
              }
              let creationCompletionCode = ''
              // 地区选出是数组，需要处理成字符串
              if (
                typeof this.form.creationCompletionCode !== 'string' &&
                this.form.creationCompletionCode
              ) {
                creationCompletionCode =
                  this.form.creationCompletionCode[
                    this.form.creationCompletionCode.length - 1
                  ]
              } else {
                creationCompletionCode = this.form.creationCompletionCode
              }

              let firstPublicationCode = ''
              // 地区选出是数组，需要处理成字符串
              if (
                typeof this.form.firstPublicationCode !== 'string' &&
                this.form.firstPublicationCode
              ) {
                firstPublicationCode =
                  this.form.firstPublicationCode[
                    this.form.firstPublicationCode.length - 1
                  ]
              } else {
                firstPublicationCode = this.form.firstPublicationCode
              }
              let worksea = {
                workFileId: workFileId, // 作品文件id
                workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
                workName: this.form.workName, // 作品名称
                workCategory: this.form.workCategory, // 作品类型
                fileType: this.form.fileType, // 文件类型
                creationNature: this.form.creationNature, // 作品创作性质
                creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
                creationCompletionCode, // 地区编码
                publicationStatus: this.form.publicationStatus, // 作品发表状态
                firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
                firstPublicationCode, // 首次发表地区编码
                fileSize, // 文件大小
                fileDurationMinutes
              }

              if (this.dciWorkId || itemListId > 0) {
                // return
                if (itemListId > 0) {
                  worksea.dciWorkId = this.sameWorkListitemID
                }
                // 更新状态
                const res = await workUpdate({ ...this.form, ...worksea })

                if (res.code == 200) {
                  // 修改某一项
                  if (itemListId > 0) {
                    this.sameWorkList[itemListId - 1] = {
                      ...worksea
                    }
                    // this.$message.success("更新作品信息成功");
                  } else {
                    this.sameWorkList.push({
                      ...worksea,
                      dciWorkId: this.dciWorkId
                    })
                  }

                  this.active = 2 // 下一步
                } else {
                  this.$message.error('更新作品信息失败' + res.msg)
                  return false
                }
              } else {
                // 新增
                const res = await workSave(worksea)
                if (res.code == 200) {
                  this.sameWorkList.push({ ...worksea, dciWorkId: res.data })

                  this.active = 2 // 下一步
                } else {
                  this.$message.error(res.msg)
                }
              }
            } else {
              this.$message.error('请填写完整信息')
              return false
            }
          })
        } else {
          this.active = 2 // 下一步
        }
        return
      }

      this.$refs.formName.validate(async valid => {
        if (valid) {
          const date1 = new Date(this.form.creationCompletionDate)
          const date2 = new Date(this.form.firstPublicationDate)

          if (date1 > date2) {
            this.$message.error('首次发表日期不能早于创作完成日期')
            return
          }
          let workFileId = ''
          let workFileIdLocal = ''
          let fileSize = ''
          let fileDurationMinutes = ''
          if (this.file) {
            let FrontFileId = new FormData()
            FrontFileId.append('file', this.file)
            const resFront = await upload(FrontFileId)
            if (resFront.code == 200) {
              workFileId = resFront.dciFile
              workFileIdLocal = resFront.ossFile
              fileSize = resFront.fileSize
              fileDurationMinutes = resFront.durationMinutes
            } else {
              this.$message.error(resFront.msg)
              return false
            }
          } else {
            if (this.dciWorkId && !this.isLook) {
              // 更新状态
              workFileId = this.form.workFileId
              workFileIdLocal = this.form.workFileIdLocal
              fileSize = this.form.fileSize
              fileDurationMinutes = this.form.fileDurationMinutes
            } else {
              this.$message.error('请填选择文件')
              return false
            }
          }
          let creationCompletionCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.creationCompletionCode !== 'string' &&
            this.form.creationCompletionCode
          ) {
            creationCompletionCode =
              this.form.creationCompletionCode[
                this.form.creationCompletionCode.length - 1
              ]
          } else {
            creationCompletionCode = this.form.creationCompletionCode
          }

          let firstPublicationCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.firstPublicationCode !== 'string' &&
            this.form.firstPublicationCode
          ) {
            firstPublicationCode =
              this.form.firstPublicationCode[
                this.form.firstPublicationCode.length - 1
              ]
          } else {
            firstPublicationCode = this.form.firstPublicationCode
          }
          let worksea = {
            workFileId: workFileId, // 作品文件id
            workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
            workName: this.form.workName, // 作品名称
            workCategory: this.form.workCategory, // 作品类型
            fileType: this.form.fileType, // 文件类型
            creationNature: this.form.creationNature, // 作品创作性质
            creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
            creationCompletionCode, // 地区编码
            publicationStatus: this.form.publicationStatus, // 作品发表状态
            firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
            firstPublicationCode, // 首次发表地区编码
            fileSize, // 文件大小
            fileDurationMinutes
          }

          if (this.dciWorkId && itemListId > 0) {
            if (itemListId > 0) {
              worksea.dciWorkId = this.sameWorkListitemID
            }
            // 更新状态
            const res = await workUpdate({ ...this.form, ...worksea })
            if (res.code == 200) {
              // 修改某一项
              if (itemListId > 0) {
                this.sameWorkList[itemListId - 1] = {
                  ...worksea
                }
                // this.$message.success("更新作品信息成功");
              } else {
                this.sameWorkList.push({
                  ...worksea,
                  dciWorkId: this.dciWorkId
                })
              }

              this.active = 2 // 下一步
            } else {
              this.$message.error('更新作品信息失败' + res.msg)
              return false
            }
          } else {
            // 新增
            const res = await workSave(worksea)
            if (res.code == 200) {
              this.sameWorkList.push({ ...worksea, dciWorkId: res.data })

              this.active = 2 // 下一步
            } else {
              this.$message.error(res.msg)
            }
          }
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    //同作者再次添加作品
    nextNewClick () {
      this.$refs.formName.validate(async valid => {
        if (valid) {
          const date1 = new Date(this.form.creationCompletionDate)
          const date2 = new Date(this.form.firstPublicationDate)

          if (date1 > date2) {
            this.$message.error('首次发表日期不能早于创作完成日期')
            return
          }

          let workFileId = ''
          let workFileIdLocal = ''
          let fileSize = ''
          let fileDurationMinutes = ''
          if (this.file) {
            let FrontFileId = new FormData()
            FrontFileId.append('file', this.file)
            const resFront = await upload(FrontFileId)
            if (resFront.code == 200) {
              workFileId = resFront.dciFile
              workFileIdLocal = resFront.ossFile
              fileSize = resFront.fileSize
              fileDurationMinutes = resFront.durationMinutes
            } else {
              this.$message.error(resFront.msg)
              return false
            }
          } else {
            if (this.dciWorkId && !this.isLook) {
              // 更新状态
              workFileId = this.dciWorkId.workFileId
              workFileIdLocal = this.dciWorkId.workFileIdLocal
              fileSize = this.dciWorkId.fileSize
              fileDurationMinutes = this.dciWorkId.fileDurationMinutes
            } else {
              this.$message.error('请填选择文件')
              return false
            }
          }
          let creationCompletionCode = ''
          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.creationCompletionCode !== 'string' &&
            this.form.creationCompletionCode
          ) {
            creationCompletionCode =
              this.form.creationCompletionCode[
                this.form.creationCompletionCode.length - 1
              ]
          } else {
            creationCompletionCode = this.form.creationCompletionCode
          }

          let firstPublicationCode = ''

          // 地区选出是数组，需要处理成字符串
          if (
            typeof this.form.firstPublicationCode !== 'string' &&
            this.form.firstPublicationCode
          ) {
            firstPublicationCode =
              this.form.firstPublicationCode[
                this.form.firstPublicationCode.length - 1
              ]
          } else {
            firstPublicationCode = this.form.firstPublicationCode
          }
          let proxy = ''
          if (this.clickinfo == 2) {
            proxy = this.userInfo.userId
          }

          let worksea = {
            workFileId: workFileId, // 作品文件id
            workFileIdLocal: workFileIdLocal, // 作品文件id本系统OSS
            workName: this.form.workName, // 作品名称
            workCategory: this.form.workCategory, // 作品类型
            fileType: this.form.fileType, // 文件类型
            creationNature: this.form.creationNature, // 作品创作性质
            creationCompletionDate: this.form.creationCompletionDate, // 创作完成日期
            creationCompletionCode, // 地区编码
            publicationStatus: this.form.publicationStatus, // 作品发表状态
            firstPublicationDate: this.form.firstPublicationDate, // 首次发表日期
            firstPublicationCode, // 首次发表地区编码
            fileSize, // 文件大小
            fileDurationMinutes,
            proxy
          }

          // this.sameWorkList.push(worksea)
          // return

          const res = await workSave(worksea)
          console.log(res)
          if (res.code == 200) {
            this.$message.success('保存成功')
            this.sameWorkList.push({ ...worksea, dciWorkId: res.data })

            // 清空字段
            this.form.workName = ''
            this.form.workCategory = ''
            this.form.fileType = ''
            this.form.creationCompletionDate = ''
            this.form.creationCompletionCode = ''
            this.form.firstPublicationDate = ''
            this.form.firstPublicationCode = ''
            this.fileList = []
          } else {
            this.$message.error(res.msg)
          }

          console.log(this.sameWorkList)
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    showStatus (r) {
      console.log(r)
    },
    copyrightDel (scope) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.sameWorkList.splice(scope.$index, 1)
      }).catch(() => {})
    },
    copyrigEdit (scope) {
      this.form = { ...scope.row }
      this.sameWorkListitemID = scope.row.dciWorkId
    },
    editInfo () {
      // 字段返现去修改
      this.form.workName = this.infoForm.workName
      this.form.workCategory = this.infoForm.workCategory
      this.form.fileType = this.infoForm.fileType
      this.form.creationCompletionDate = this.infoForm.creationCompletionDate
      this.form.creationCompletionCode = this.infoForm.creationCompletionCode
      this.form.firstPublicationDate = this.infoForm.firstPublicationDate
      this.form.firstPublicationCode = this.infoForm.firstPublicationCode
      this.sameWorkListitemID = this.infoForm.dciWorkId

      this.active = 1
    }
  }
}
</script>
<style lang="scss" scoped>
.title-jibne {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.stepscc {
  margin: 30px auto;
  width: 1200px;
}

.asefaeaf {
  padding: 20px;
  background-color: rgba(242, 242, 242, 1);
}
.unslider {
  margin: 0 auto;
  width: 1200px;
  height: 866px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  > div {
    width: 470px;
    height: 380px;
    border-style: solid;
    border-color: rgba(121, 121, 121, 1);
    border-radius: 10px;
    border-width: 1px;
    text-align: center;
    display: flex;
    &:hover {
      cursor: pointer;
    }
    flex-direction: column;
    justify-content: center;
    > :nth-child(1) {
      font-size: 160px;
    }
    > :nth-child(2) {
      margin: 20px;
      letter-spacing: normal;
      color: #333333;
      line-height: normal;
      font-size: 24px;
      font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
      font-weight: 700;
      font-style: normal;
      white-space: nowrap;
      text-transform: none;
      text-rendering: optimizeLegibility;
      -webkit-font-feature-settings: 'kern';
      font-kerning: normal;
    }
  }
}

.form-aut {
  margin: 0 auto;
  width: 800px;
}
.el-select-cc {
  width: 500px;
}
.card-aut-cc {
  margin-top: 10px;
}
.span-cc {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  word-wrap: break-word;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
  margin-bottom: 10px;
}
.nave-dd {
  background-color: #f2f2f2;
  padding: 10px 20px 10px 20px;
}
.seccbtn {
  display: flex;
  > div {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    background: inherit;
    background-color: rgba(242, 242, 242, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #000000;
    line-height: 51px;
    margin-right: 15px;
    cursor: not-allowed;
  }

  .chekbtn {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    line-height: 51px;
    background: inherit;
    background-color: rgba(0, 121, 254, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #ffffff;
  }
}
.showStatus-monitor {
  display: flex;
  > :nth-child(2) {
    margin-left: 50px;
  }
}
.seccbtn-sfda {
  display: flex;
  > div {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    background: inherit;
    background-color: rgba(242, 242, 242, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #000000;
    line-height: 51px;
    margin-right: 15px;
    cursor: pointer;
  }

  .chekbtn {
    visibility: inherit;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
    width: 159px;
    height: 51px;
    line-height: 51px;
    background: inherit;
    background-color: rgba(0, 121, 254, 1);
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    box-shadow: none;
    color: #ffffff;
  }
}

.haoma-css {
  > div {
    margin: 10px 0;
  }
  .haoma-css-cc {
    display: flex;
    > :nth-child(1) {
      width: 150px;
      font-size: 16px;
      line-height: 40px;
      font-weight: 700;
    }
    > :nth-child(2) {
      width: 328px;
      .el-input-cc {
        width: 100%;
      }
    }
  }
}
.aewfasef {
  margin-top: 20px;
  padding: 20px;
}
.haoma-css-cc-no1 {
  padding-left: 100px;
}
.btn-cc-disc {
  margin-top: 15px;
}
.table-dci {
  margin-bottom: 20px;
}
.btn-cc-gres {
  margin-top: 15px;
}
.never-span-cc {
  width: 100%;
  display: flex;
  > div {
    flex: 1;
    .nawe-sadg {
      display: flex;

      > :nth-child(n) {
        line-height: 50px;
      }
      > :nth-child(1) {
        width: 150px;
        font-size: 16px;
        font-weight: 700;
        line-height: 50px;
      }
      .nawe-sadg-sdfa {
        margin-left: 10px;
      }

      .showStatus-cc {
      }
      .showStatus-time {
        font-family: 'Arial Normal', 'Arial', sans-serif;
        font-weight: 400;
        font-style: normal;
        letter-spacing: normal;
        line-height: normal;
        font-size: 14px;
        text-align: left;
        color: #797979;
        white-space: nowrap;
        text-transform: none;
        text-rendering: optimizeLegibility;
        -webkit-font-feature-settings: 'kern';
        font-kerning: normal;
        text-align: center;
        margin-top: 5px;
      }
    }
  }
}

.asfsaefae {
  margin-left: 20px;
  font-size: 14px;
  font-weight: 700;
}
.title-jibne-fsa {
  // width: 500px;
  // height: 300px;
  font-size: 150px;

  :hover {
    color: #000000;
    cursor: pointer;
  }
}
.gewgssese {
  width: 80%;
}
.btn-isooreview {
  min-height: 500px;
}
.fail-detail {
  color: red;
}
</style>
